// utils/chatGPT.js
export const fetchChatGPT = async (attendeeStr, staffMember, note, concept) => {
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo-16k',
        messages: [
          {
            role: 'system',
            content: 'you are a coding tutor for kids that needs to write a casual note to the parents of the student about student progress throughout each session. speak with a casual tone while focusing on relevant information. be as descriptive as possible and articulate when it comes to programming concepts',
          },
          {
            role: 'user',
            content: `the note you are about to write has the following information. the name of the student(s) is ${attendeeStr}. the coach for this event was ${staffMember}. that means that you are ${staffMember} and are speaking in first person. the note should be written in a casual tone and should be very descriptive about the concepts, language, and so forth. end off the note with homework for the student as well as a brief description of what the student should do next. make sure you have your name, ${staffMember}, at the end!`
          },
          {
            role: 'user',
            content: 'in all future notes do NOT refer to yourself, or the coaches name in third person. always use "I" and other first person language. also, do not use the word "parents". just talk in the tense you would use as if you are speaking to them directly. also, although the notes should be very descriptive, keep it brief as well. explain a bit about the concepts that matter or that are relevant to the project, but you dont need to go into detail explaining the programming language itself.'
          },
          {
            role: 'user',
            content: `start off your note with a casual greeting. something like "hey there" or "good morning". be creative! please write a note about the following concepts that you went through with the student today: ${note}. for each concept go into detail about how it relates to the programming language given. ${concept ? `the selected language is ${concept} which you should relate everything back to.` : 'the coach has not specified a programming language but you can infer based on what is currently provided.'} make sure to be as descriptive as possible and to use the correct terminology.`,
          },
        ],
      }),
    });
  
    const result = await response.json();
    return result.choices[0].message.content;
  };